import React from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

const DropdownFilter = ({
  label,
  value,
  options = [],
  onChange,
  buttonClass = "btn-neutral",
  capitalize = false,
  disabled = false,
}) => {
  const selectedOption =
    options.find((opt) => opt.value === value) || options[0] || {};

  return (
    <div className="d-flex align-items-center mr-3">
      {label && (
        <span className="text-sm font-weight-600 text-muted mr-2">
          {label}
        </span>
      )}

      <UncontrolledDropdown>
        <DropdownToggle
          caret
          disabled={disabled}
          className={`${buttonClass} ${capitalize ? "text-capitalize" : ""}`}
        >
          {selectedOption.label || "Select"}
        </DropdownToggle>

        <DropdownMenu right>
          {options.length > 0 && (
            <>
              <DropdownItem
                key={options[0].value}
                active={options[0].value === value}
                onClick={() => onChange(options[0].value)}
              >
                {options[0].label}
              </DropdownItem>

              <DropdownItem divider />
            </>
          )}

          {options.slice(1).map((option) => (
            <DropdownItem
              key={option.value}
              active={option.value === value}
              onClick={() => onChange(option.value)}
            >
              {option.label}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </UncontrolledDropdown>
    </div>
  );
};

export default DropdownFilter;
